import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SchoolInformation from "./routes/SchoolInformation";

export default store => ({
  path: "school-details",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "school-information" */ "./components/SchoolInformationWrapper"
      ),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [SchoolInformation(store)],
});
